import React from 'react';

// Components
import Toolbar from '../../components/UI/Toolbar/Toolbar';
import VisitRoutes from '../../components/VisitRoutesPage/VisitRoutes/VisitRoutes';

// VisitRoutesPage: renders a toolbar and the VisitRoutes component
const VisitRoutesPage: React.FC = () => {
    return(
        <div className='pageContainer'>
            <Toolbar />
            <VisitRoutes />
        </div>
    );
};
export default VisitRoutesPage;